import { render, staticRenderFns } from "./RecentExam.vue?vue&type=template&id=0553e364&scoped=true"
import script from "./RecentExam.vue?vue&type=script&lang=js"
export * from "./RecentExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553e364",
  null
  
)

export default component.exports